import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { brands } from "@fortawesome/fontawesome-svg-core/import.macro";

import styles from "./social.module.scss";

const Social = (props) => {
    return (
        <div className={styles.social}>
            <div className={styles.social__links}>
                <a
                    rel="noreferrer"
                    className={styles.linkedin}
                    href={props.linkedIn}
                    target="_blank"
                >
                    <FontAwesomeIcon
                        icon={brands("linkedin")}
                        size="3x"
                        color="#0077b5"
                    />
                </a>
            </div>
        </div>
    );
};

export default Social;
